// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.hero {
  padding: 0 18px;
}
section.hero .hero-body {
  flex-grow: 1;
  flex-shrink: 0;
  padding: 1rem 0 0.5rem 0;
}

.main-section {
  padding: 0.5rem 1.5rem 0rem 1.5rem;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/assets/css/hero.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AAAE;EACE,YAAA;EACA,cAAA;EACA,wBAAA;AAEJ;;AAEA;EACE,kCAAA;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
